import { render, staticRenderFns } from "./batchPrice.vue?vue&type=template&id=b4ff692e&scoped=true"
import script from "./batchPrice.vue?vue&type=script&lang=js"
export * from "./batchPrice.vue?vue&type=script&lang=js"
import style0 from "./batchPrice.vue?vue&type=style&index=0&id=b4ff692e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ff692e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4ff692e')) {
      api.createRecord('b4ff692e', component.options)
    } else {
      api.reload('b4ff692e', component.options)
    }
    module.hot.accept("./batchPrice.vue?vue&type=template&id=b4ff692e&scoped=true", function () {
      api.rerender('b4ff692e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/batchPrice.vue"
export default component.exports